const EMAIL_PATTERN_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
const UPLOAD_IMAGE_PATTERN_REGEX = /\.(jpg|jpeg|png|gif|JPG|JPEG|PNG|GIF)$/;

const TAG_USER_TYPE = {
  ORG_ADMIN: { key: "ORG_ADMIN", value: "Administrator" },
  TEAM_MEMBER: { key: "TEAM_MEMBER", value: "Member" },
};

const APP_MODE = {
  FULL: { key: 1, value: "Full" },
  LIGHT: { key: 2, value: "Light" },
};

export default {
  EMAIL_PATTERN_REGEX,
  UPLOAD_IMAGE_PATTERN_REGEX,
  TAG_USER_TYPE,
  APP_MODE,
};
